module.exports = __webpack_public_path__ + "img/beian.e26df106.png";